import * as React from 'react';
import { TextDirection } from './textDirection';
import { useSelector } from 'react-redux';
import { AppState } from '../core/redux/appState';
import { strictEquals } from '../language/module';


interface Props extends React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> {
  forceDirection?: TextDirection;
}

/**
 * LocalSelect: a component that
 *
 * PureComponent: true
 * Redux Connected: false
 */
const LocalSelect: React.FC<Props> = props => {
  const { forceDirection, ...rest } = props;

  const layoutDirection = useSelector<AppState, TextDirection>(
    state => state.locale.textDirection,
    strictEquals,
  );

  return(
  <select {...rest} dir={forceDirection ?? layoutDirection}>
    {props.children}
  </select>
  );
};

export default LocalSelect;